import authenticate from "@/auth/authenticate";
import hasPermission from "@/auth/hasPermission";

export default [
  {
    path: "/support",
    component: () => import("@/views/global/Clear"),
    beforeEnter: authenticate,
    children: [
      {
        path: "",
        name: "support",
        beforeEnter: hasPermission,
        component: () => import("@/views/support/Index.vue"),
        meta: { permission: 4 },
      },
    ]
  },
];
